import React, { useEffect, useState } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap";
import { IoHomeOutline } from "react-icons/io5";
import { AllUsers, GetAllManagerUsers } from "../../utils/proxy/Authproxy";
import Select from "react-select";
import { Op_per } from "../../utils/Permissions";
import LoadingComponent from "../Includes/LoadingComponent";
import {
  GetMetVisitSummary,
  GetMetCountVisitSummary,
  GetCategorySummaryReport,
} from "../../utils/proxy/ChartsProxy";
import { Parser } from "@json2csv/plainjs";
import { RiFileExcel2Fill } from "react-icons/ri";
import Swal from "sweetalert2";
import Helper from "../../utils/helperFunctions";
const CategoryWiseReport = () => {
  const months = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const [data, setData] = useState([]);
  const [userid, setUserId] = useState(
    localStorage.getItem("role") === "User"
      ? localStorage.getItem("uuid")
      : null
  );
  const [selectedUser, setSelectedUser] = useState();
  const [selectedType, setSelectedType] = useState({
    value: "doctor",
    label: "Doctor",
  });
  const [type, setType] = useState("doctor");
  const [users, setUsers] = useState([]);
  const [start, setStart] = useState();
  const [end, setEnd] = useState();
  const [reload, setReload] = useState(false);
  const [pending, setPending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [metData, setMetData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [warning, setWarning] = useState("");
  const [headerDoctorStats, setHeaderDoctorStats] = useState([]);

  useEffect(() => {
    // Fetch data from an API when the component mounts
    const getallusers = async () => {
      if (localStorage.getItem("role") === "Admin") {
        let allusers = await AllUsers();
        allusers.push({
          firstname: localStorage.getItem("firstname"),
          lastname: localStorage.getItem("lastname"),
          userid: localStorage.getItem("uuid"),
          username: localStorage.getItem("username"),
        });
        setUsers(allusers);
      } else if (localStorage.getItem("role") === "Manager") {
        let allusers = await GetAllManagerUsers(localStorage.getItem("uuid"));
        setUsers(allusers);
      }
    };
    getallusers();
  }, []);

//   useEffect(() => {
//     // Fetch data from an API when the component mounts
//     const getallteritories = async (userid, from, to, type) => {
//       let userteritories = await GetCategorySummaryReport(
//         userid,
//         from,
//         to,
//         type
//       );

//       if (userteritories) {
//         setData(userteritories);
//         setPending(false);

//         if (
//           userteritories?.length > 0 &&
//           userteritories[0].analysis?.[0]?.doctorStats
//         ) {
//           const stats = userteritories[0].analysis[0].doctorStats.map(
//             (stat) => ({
//               doctor_class: stat.doctor_class,
//             })
//           );
//           // Sort the headerDoctorStats to ensure 'Total' comes first
//           const sortedHeaderDoctorStats = (stats || []).sort((a, b) => {
//             if (a.doctor_class === "Total") return -1; // Move 'Total' to the top
//             if (b.doctor_class === "Total") return 1;
//             return 0; // Keep the order of other items the same
//           });
//           setHeaderDoctorStats(sortedHeaderDoctorStats);
//         }
//       } else {
//         alert("Error", "Issue While Fetching Tour Plan");
//       }
//     };
//     if (userid && start && end) {
//       setPending(true);
//       getallteritories(userid, start, end, type);
//     }
//     setReload(false);
//   }, [reload, userid, start, end, type]);

useEffect(() => {
  const getallteritories = async (userid, from, to, type) => {
    let userteritories = await GetCategorySummaryReport(
      userid,
      from,
      to,
      type
    );

    if (!userteritories) {
      alert("Error", "Issue While Fetching Tour Plan");
      return;
    }

    setData(userteritories);
    setPending(false);

    // 🔥 Find the FIRST user that contains doctorStats
    const validUser = userteritories.find(
      (u) => u?.analysis?.[0]?.doctorStats?.length > 0
    );

    if (validUser) {
      const stats = validUser.analysis[0].doctorStats.map((stat) => ({
        doctor_class: stat.doctor_class,
      }));

      // Sort: "Total" always first
      const sortedHeaderDoctorStats = stats.sort((a, b) => {
        if (a.doctor_class === "Total") return -1;
        if (b.doctor_class === "Total") return 1;
        return 0;
      });

      setHeaderDoctorStats(sortedHeaderDoctorStats);
    } else {
      // If NO users have doctorStats → set empty header
      setHeaderDoctorStats([]);
    }
  };

  if (userid && start && end) {
    setPending(true);
    getallteritories(userid, start, end, type);
  }

  setReload(false);
}, [reload, userid, start, end, type]);

  const handleSelectChange = (selected) => {
    setUserId(selected.value);
    setSelectedUser(selected);
  };

  const handleStartMonth = (value) => {
    setStart(value);
  };

  const handleTypeChange = (selected) => {
    setSelectedType(selected);
    setType(selected.value);
  };

  const handleMetClick = async (userid, start, type, count) => {
    if (count != 0) {
      let d = await GetMetVisitSummary(userid, start, type);
      if (d) {
        setMetData(d);
        setFileName("Met Analysis");
        setShowModal(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Something Went wrong",
          icon: "error",
        });
      }
    }
  };

  const handleOnceMetClick = async (userid, start, type, count) => {
    if (count != 0) {
      let d = await GetMetCountVisitSummary(userid, 1, start, type);
      if (d) {
        setMetData(d);
        setFileName("Met Once Analysis");
        setShowModal(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Something Went wrong",
          icon: "error",
        });
      }
    }
  };

  const handleTwiceMetClick = async (userid, start, type, count) => {
    if (count != 0) {
      let d = await GetMetCountVisitSummary(userid, 2, start, type);
      if (d) {
        setMetData(d);
        setFileName("Met Twice Analysis");
        setShowModal(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Something Went wrong",
          icon: "error",
        });
      }
    }
  };

  const handleMoreThanTwiceMetClick = async (userid, start, type, count) => {
    if (count != 0) {
      let d = await GetMetCountVisitSummary(userid, 3, start, type);
      if (d) {
        setMetData(d);
        setFileName("Met More Than Twice Analysis");
        setShowModal(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Something Went wrong",
          icon: "error",
        });
      }
    }
  };

  const options = [];
  const typeoptions = [
    { value: "doctor", label: "Doctor" },
    { value: "hospital", label: "Hospital" },
  ];

  users.map((user) => {
    options.push({
      value: user.userid,
      label: user.username + "(" + user.firstname + " " + user.lastname + ")",
      name: user.username,
    });
  });

  function downloadCSV(data, type) {
    if (type !== "doctor" && type !== "hospital") {
      Swal.fire({
        title: "Validation Error",
        text: 'Invalid type. Must be either "doctor" or "hospital".',
        icon: "warning",
      });
      return;
    }
    if (!selectedUser) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select a user.",
        icon: "warning",
      });
      return;
    }

    if (!start) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select the start month.",
        icon: "warning",
      });
      return;
    }

    if (!end) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select the end month.",
        icon: "warning",
      });
      return;
    }

    if (end < start) {
      Swal.fire({
        title: "Validation Error",
        text: "End month cannot be earlier than start month.",
        icon: "warning",
      });
      return;
    }

    if (!selectedType) {
      Swal.fire({
        title: "Validation Error",
        text: "Please select a type.",
        icon: "warning",
      });
      return;
    }
    const escapeCSV = (cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`;

    const doctorStatsColSpan = headerDoctorStats.length * 3;

    // Calculate how many empty cells on each side to center the label
    const emptyCellsBefore = Math.floor((doctorStatsColSpan - 1) / 2);
    const emptyCellsAfter = doctorStatsColSpan - 1 - emptyCellsBefore;

    type === "doctor"
      ? setFileName("DoctorCategoryAnalysis")
      : setFileName("HospitalCategoryAnalysis");
    const headerRow1 = [
      "FieldForce Name",
      "Designation",
      "HQ",
      "DOJ",
      "Month",
      ...Array(emptyCellsBefore).fill(""),
      `${type === "doctor" ? "Doctor" : "Hospital"} Call Details`,
      ...Array(emptyCellsAfter).fill(""),
      `Total ${type == "doctor" ? "Doctor" : "Hospital"} Call`,
      "",
      "",
      "Call Details",
      "",
      "",
      "",
      "Daywise",
      "",
      "",
      "Territory Coverage",
      "",
      "",
      "Total",
      "",
    ];

    const headerRow2 = [
      "",
      "",
      "",
      "",
      "",
      ...headerDoctorStats
        .map((hds) => hds.doctor_class)
        .flatMap((dc) => [dc, "", ""]),
      "Morning",
      "Evening",
      "Avg",
      "Missed",
      `${type === "doctor" ? "Dr" : "Hosp"} Met 1`,
      `${type == "doctor" ? "Dr" : "Hosp"} Met 2`,
      `${type == "doctor" ? "Dr" : "Hosp"} Met above 2`,
      "Worked",
      "Leave",
      "Holiday",
      "HQ",
      "EX",
      "OS",
      "Met",
      "Seen",
    ];

    const headerRow3 = [
      "",
      "",
      "",
      "",
      "",
      ...headerDoctorStats.flatMap(() => ["List", "Met", "Seen"]),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];

    const rows = [headerRow1, headerRow2, headerRow3];

    data.forEach((dt) => {
      let firstRowForUser = true;
      dt.analysis.forEach((an) => {
        const row = [];
        const result = getDoctorStatsForMonth(dt.uuid, an.month) || {};

        if (firstRowForUser) {
          row.push(dt.username ?? "n/a");
          row.push(dt.designation ?? "n/a");
          row.push(dt.headquator ?? "n/a");
          row.push(dt.doj ?? "n/a");
          firstRowForUser = false; // Clear flag after first row
        } else {
          // Leave these cells empty for subsequent rows
          row.push("", "", "", "");
        }

        const [year, monthNum] = an.month.split("-");
        row.push(`${year}-${months[monthNum] ?? monthNum}`);

        headerDoctorStats.forEach((hds) => {
          const stats =
            an.doctorStats.find(
              (stat) => stat.doctor_class === hds.doctor_class
            ) || {};
          row.push(stats.total_doctors_assigned ?? "n/a");
          row.push(stats.total_met ?? "n/a");
          row.push(stats.total_dcr ?? "n/a");
        });

        row.push(an.morningcalls ?? "n/a");
        row.push(an.eveningcalls ?? "n/a");
        row.push(an.dr_call_average ?? "n/a");

        row.push(result.missed ?? "n/a");
        row.push(an.met1time ?? "n/a");
        row.push(an.met2time ?? "n/a");
        row.push(an.metabove3time ?? "n/a");

        row.push(an.workeddays ?? "n/a");
        row.push(an.leaves ?? "n/a");
        row.push(an.holidays ?? "n/a");

        row.push(an.hq_count ?? "n/a");
        row.push(an.ex_count ?? "n/a");
        row.push(an.ot_count ?? "n/a");

        row.push(result.total_dr_met ?? "n/a");
        row.push(result.total_dr_seen ?? "n/a");

        rows.push(row);
      });
    });

    // Convert to CSV string
    const csvContent = rows
      .map((row) => row.map(escapeCSV).join(","))
      .join("\n");

    // Optional title/header at the top (not part of table)
    const csvHeaderText = `CategoryAnalysis (${type}) [${selectedUser.name}] ${start} to ${end}\n\n`;
    const finalCSV = "\uFEFF" + csvHeaderText + csvContent;

    const blob = new Blob([finalCSV], { type: "text/csv;charset=utf-8;" });

    const filename = `CategoryAnalysis(${type})[${selectedUser.name}]-${start}to${end}.csv`;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function downloadVisitedCSV(plans) {
    let csv;
    try {
      const opts = {
        fields: Object.entries(metData[0]).map(([key, value]) => ({
          label: key,
          value: key,
        })),
        transforms: [
          (row) => {
            if (row.date) {
              row.date = Helper.ConvertUtcToLocalTime(row.date);
            }
            return row;
          },
        ],
      };
      const parser = new Parser(opts);
      csv = parser.parse(plans);
    } catch (err) {
      console.error(err);
    }

    const link = document.createElement("a");

    if (csv == null) return;

    // Modify the filename
    const filename = `${type} ${fileName}[${selectedUser.name}]-${start}to${end}.csv`;

    // Insert placeholder values for colspan/rowspan
    // csv = `VisitAnalysis (${type}) ${start} to ${end} \n\n\n${csv}`;

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }

  // const getDoctorStatsForMonth = (userId, month) => {

  //   const userData = data.find(user => user.uuid === userId);

  //   if (!userData) return null;

  //   const monthData = userData.analysis.find(an => an.month === month);

  //   if (!monthData) return null;

  // const total_dr_met = monthData.doctorStats.reduce((accumulator, currentValue) => {
  //   if (currentValue.doctor_class === "Total") return accumulator;
  //   return accumulator + currentValue.total_met;
  // }, 0);

  // const total_dr_seen = monthData.doctorStats.reduce((accumulator, currentValue) => {
  //   if (currentValue.doctor_class === "Total") return accumulator;
  //   return accumulator + currentValue.total_dcr;
  // }, 0);

  //   const missed = monthData.doctorStats.find(d => d.doctor_class === "Total")?.total_doctors_assigned - total_dr_met || 0;

  //   return { total_dr_met, total_dr_seen, missed };
  // };

  const getDoctorStatsForMonth = (userId, month) => {
    const userData = data.find((user) => user.uuid === userId);
    if (!userData) return { total_dr_met: 0, total_dr_seen: 0, missed: 0 };

    const monthData = userData.analysis?.find((an) => an.month === month);
    if (!monthData) return { total_dr_met: 0, total_dr_seen: 0, missed: 0 };

    const doctorStatsList = monthData.doctorStats || [];

    const total_dr_met = doctorStatsList
      .filter((ds) => ds.doctor_class !== "Total")
      .reduce((acc, curr) => acc + (curr.total_met || 0), 0);

    const total_dr_seen = doctorStatsList
      .filter((ds) => ds.doctor_class !== "Total")
      .reduce((acc, curr) => acc + (curr.total_dcr || 0), 0);

    const totalObj = doctorStatsList.find((d) => d.doctor_class === "Total");
    const totalAssigned = totalObj?.total_doctors_assigned || 0;

    return {
      total_dr_met,
      total_dr_seen,
      missed: totalAssigned - total_dr_met,
    };
  };

  return (
    <Container fluid style={{ minHeight: "80vh" }}>
      <div
        className="glass-body"
        style={{
          margin: 10,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 0,
          backgroundColor: "transparent",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ul id="breadcrumb">
            <li>
              <a href="/">
                <IoHomeOutline style={{ color: "white", fontSize: 20 }} />
              </a>
            </li>
            <li>
              <a href="/visit-analysis">
                <span class="icon icon-beaker"> </span>Reports
              </a>
            </li>

            <li>
              <a href="#">
                <span class="icon icon-double-angle-right"></span>Categorywise
                Visit Analysis
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="glass-body" style={{ margin: 10 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
          }}
          className="flex-column-mobile"
        >
          <div
            style={{
              width: "250px",
              display: Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.USER_DROPDOWN
                ? ""
                : "none",
            }}
          >
            <Form.Group
              className="mb-3 d-flex w-100"
              style={{ gap: "15px" }}
              controlId="formBasicPassword"
            >
              <Form.Label className="mt-2">Users</Form.Label>
              <div className="w-75">
                <Select
                  className="selectdoctor"
                  options={options}
                  value={selectedUser}
                  onChange={handleSelectChange}
                  styles={{
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      color: "#ccc", // Change color of the arrow here
                    }),
                  }}
                />
              </div>
            </Form.Group>
          </div>
          <div style={{ width: "250px" }}>
            <Form.Group
              className="mb-3 d-flex w-100"
              style={{ gap: "15px" }}
              controlId="formBasicPassword"
            >
              <Form.Label className="mt-2">From</Form.Label>
              <div className="w-75">
                <input
                  className="selectdoctor"
                  type="month"
                  id="start"
                  name="start"
                  onChange={(e) => handleStartMonth(e.target.value)}
                  value={start}
                />
              </div>
            </Form.Group>
          </div>
          <div style={{ width: "250px" }}>
            <Form.Group
              className="mb-3 d-flex w-100"
              style={{ gap: "15px" }}
              controlId="formBasicPassword"
            >
              <Form.Label className="mt-2">To</Form.Label>
              <div className="w-75">
                <input
                  className="selectdoctor"
                  type="month"
                  id="start"
                  name="end"
                  onChange={(e) => setEnd(e.target.value)}
                  value={end}
                />
              </div>
            </Form.Group>
            {warning && (
              <small style={{ color: "red", marginTop: "4px" }}>
                {warning}
              </small>
            )}
          </div>
          <div style={{ width: "320px" }}>
            <Form.Group
              className="mb-3 d-flex w-100"
              style={{ gap: "15px" }}
              controlId="formBasicPassword"
            >
              <Form.Label className="mt-2">Type</Form.Label>
              <div className="w-75">
                <Select
                  className="selectdoctor"
                  options={typeoptions}
                  value={selectedType}
                  onChange={handleTypeChange}
                  styles={{
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      color: "#ccc", // Change color of the arrow here
                    }),
                  }}
                />
              </div>
            </Form.Group>
          </div>
          <div>
            <Button onClick={() => downloadCSV(data, type)}>
              <RiFileExcel2Fill />
            </Button>
          </div>
        </div>

        {pending ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <LoadingComponent />
          </div>
        ) : (
          <div style={{ width: "100%", overflowX: "auto", padding: "10px 0" }}>
            {data.length > 0 ? (
              <div
                className="pt-3 overflow-x-auto"
                style={{
                  height: "65vh",
                  overflowY: "auto",
                  overflowX: "auto",
                  scrollbarWidth: "thin",
                }}
              >
                <table className="tg">
                  <thead className="bg-gray-200">
                    {/* First Header Row */}
                    <tr>
                      <th rowSpan="3" className="tg-0pky px-2">
                        FieldForce Name
                      </th>
                      <th rowSpan="3" className="tg-0pky px-2">
                        Designation
                      </th>
                      <th rowSpan="3" className="tg-0pky px-2">
                        HQ
                      </th>
                      <th rowSpan="3" className="tg-0pky px-2">
                        DOJ
                      </th>
                      <th rowSpan="3" className="tg-0pky px-2">
                        Month
                      </th>

                      {/* These get filled by doctor_class */}
                      <th
                        colSpan={(headerDoctorStats?.length || 0) * 3}
                        className="tg-0pky text-center"
                      >
                        {type === "doctor" ? "Dr" : "Hos"} Call Details
                      </th>

                      <th colSpan="3" className="tg-0pky text-center">
                        Total {type === "doctor" ? "Dr" : "Hos"} Call
                      </th>
                      <th colSpan="4" className="tg-0pky text-center">
                        Call Details
                      </th>
                      <th colSpan="3" className="tg-0pky text-center">
                        Daywise
                      </th>
                      <th colSpan="3" className="tg-0pky text-center">
                        Territory Coverage
                      </th>
                      <th colSpan="2" className="tg-0pky text-center">
                        Total
                      </th>
                    </tr>

                    {/* Second Header Row */}
                    <tr>
                      {(headerDoctorStats || []).map((element, index) => (
                        <th
                          key={`doctor-class-${index}`}
                          colSpan="3"
                          className="tg-0pky"
                        >
                          {element.doctor_class}
                        </th>
                      ))}
                      <th rowSpan="2" className="tg-0pky">
                        Morning
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Evening
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Avg
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Missed
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        {type === "doctor" ? "Dr" : "Hos"} Met 1
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        {type === "doctor" ? "Dr" : "Hos"} Met 2
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        {type === "doctor" ? "Dr" : "Hos"} Met Above 2
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Worked
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Leave
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Holiday
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        HQ
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        EX
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        OS
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Met
                      </th>
                      <th rowSpan="2" className="tg-0pky">
                        Seen
                      </th>
                    </tr>

                    {/* Third Header Row */}
                    <tr>
                      {(headerDoctorStats || []).map((_, index) => (
                        <React.Fragment key={`header-sub-${index}`}>
                          <th className="tg-0pky">List</th>
                          <th className="tg-0pky">Met</th>
                          <th className="tg-0pky">Seen</th>
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {data.map((dt) => (
                      <>
                        <tr key={dt.username}>
                          <td class="tg-0pky" rowspan={dt.analysis.length + 1}>
                            {dt.username}
                          </td>
                          <td class="tg-0pky" rowspan={dt.analysis.length + 1}>
                            {dt.designation}
                          </td>
                          <td class="tg-0pky" rowspan={dt.analysis.length + 1}>
                            {dt.headquator}
                          </td>
                          <td class="tg-0pky" rowspan={dt.analysis.length + 1}>
                            {dt.doj}
                          </td>
                        </tr>
                        {dt.analysis.map((an, index) => {
                          // Call the getDoctorStatsForMonth function here
                          const doctorStats = getDoctorStatsForMonth(
                            dt.uuid,
                            an.month
                          );
                          return (
                            <tr key={index}>
                              <td className="tg-0lax">
                                {an.month.split("-")[0] +
                                  "-" +
                                  months[an.month.split("-")[1]]}
                              </td>

                              {headerDoctorStats &&
                                headerDoctorStats.map((element, index) => {
                                  const stats =
                                    (an.doctorStats || []).find(
                                      (stat) =>
                                        stat.doctor_class ===
                                        element.doctor_class
                                    ) || {};

                                  return (
                                    <React.Fragment key={index}>
                                      <td className="tg-0lax">
                                        {stats.total_doctors_assigned
                                          ? stats.total_doctors_assigned
                                          : 0}
                                      </td>
                                      <td className="tg-0lax">
                                        {stats.total_met ? stats.total_met : 0}
                                      </td>
                                      <td className="tg-0lax">
                                        {stats.total_dcr ? stats.total_dcr : 0}
                                      </td>
                                    </React.Fragment>
                                  );
                                })}

                              <td className="tg-0lax">{an.morningcalls}</td>
                              <td className="tg-0lax">{an.eveningcalls}</td>
                              <td className="tg-0lax">{an.dr_call_average}</td>

                              <td className="tg-0lax">{doctorStats.missed}</td>
                              <td
                                style={{ color: an.met1time > 0 ? "blue" : "" }}
                                className="tg-0lax cursor"
                                onClick={() =>
                                  handleOnceMetClick(
                                    dt.uuid,
                                    an.month,
                                    type,
                                    an.met1time
                                  )
                                }
                              >
                                {an.met1time}
                              </td>
                              <td
                                style={{ color: an.met2time > 0 ? "blue" : "" }}
                                className="tg-0lax cursor"
                                onClick={() =>
                                  handleTwiceMetClick(
                                    dt.uuid,
                                    an.month,
                                    type,
                                    an.met2time
                                  )
                                }
                              >
                                {an.met2time}
                              </td>
                              <td
                                style={{
                                  color: an.metabove3time > 0 ? "blue" : "",
                                }}
                                className="tg-0lax cursor"
                                onClick={() =>
                                  handleMoreThanTwiceMetClick(
                                    dt.uuid,
                                    an.month,
                                    type,
                                    an.metabove3time
                                  )
                                }
                              >
                                {an.metabove3time}
                              </td>
                              <td className="tg-0lax">{an.workeddays}</td>
                              <td className="tg-0lax">{an.leaves}</td>
                              <td className="tg-0lax">{an.holidays}</td>

                              <td className="tg-0lax">{an.hq_count}</td>
                              <td className="tg-0lax">{an.ex_count}</td>
                              <td className="tg-0lax">{an.ot_count}</td>

                              <td className="tg-0lax">
                                {doctorStats.total_dr_met}
                              </td>
                              <td className="tg-0lax">
                                {doctorStats.total_dr_seen}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                There are no records to display
              </div>
            )}
          </div>
        )}
        <Modal
          size="lg"
          style={{ height: "80%", overflow: "auto" }}
          show={showModal}
          onHide={() => setShowModal(false)}
        >
          <Modal.Body>
            <div
              style={{ height: "390px", scrollbarWidth: "thin" }}
              className="overflow-auto"
            >
              {metData.length > 0 && (
                <table className="table">
                  <thead>
                    <tr>
                      {Object.entries(metData[0]).map(([key, value]) => (
                        <th style={{ border: "1px solid black" }}>{key}</th>
                      ))}
                    </tr>
                  </thead>
                  {metData.map((obj) => (
                    <tbody>
                      <tr>
                        {Object.entries(obj).map(([key, value], index) => (
                          <td style={{ border: "1px solid black" }} key={index}>
                            {key === "date"
                              ? Helper.ConvertUtcToLocalTime(value)
                              : value ?? "--"}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  ))}
                </table>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ background: "#217346" }}
              onClick={() => downloadVisitedCSV(metData)}
            >
              Excel
            </Button>
            <Button onClick={() => setShowModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Container>
  );
};

export default CategoryWiseReport;
